import { Box, Drawer } from '@mui/material';
import { styled } from '@mui/material/styles';

const NavMenuBox = styled((props) => (
    <Drawer
        anchor="right"
        transitionDuration={360}
        {...props}
    />
))(({ theme }) => ({
}));

export default function NavMenu(props) {
    const { open, children } = props;

    return (
        <NavMenuBox open={open}>
            <Box sx={{
                width: "100vw",
                height: "100vh",
            }}>
                {children}
            </Box>
        </NavMenuBox>
    );
};